import {Component} from '@angular/core';
import {
    AlertController, IonicPage, LoadingController, ModalController, NavController, NavParams,
    Platform
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {SocialSharing} from "@ionic-native/social-sharing";
import {FeesPage} from "../fees/fees";


@Component({
    selector: 'page-erp-admission',
    templateUrl: 'erp-admission.html',
})
export class ErpAdmissionPage {

    Standard = 'All';
    StandardData = {};

    AcademicYear: any;
    AcademicYearData: any;

    AdmissionData = [];
    datanotfound: any;
    DataSearch: any;

    StdCount_0: any;
    StdCount_1: any;
    StdCount_2: any;
    StdCount_3: any;
    StdCount_4: any;
    StdCount_5: any;
    StdCount_6: any;
    StdCount_7: any;

    IsSearch = 0;
    Page = 1;

    School = 'GEIS';
    SchoolData = {};

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public platform: Platform,
                private socialSharing: SocialSharing,
                public service: ServiceProvider,
                public alertCtrl: AlertController,
                public loadingCtrl: LoadingController,
                public modalCtrl: ModalController) {
        this.platform.ready().then(() => {

            this.SchoolData = {
                "GWW": 2,
                "GWE": 3,
                "GEIS": 1
            };

            this.loadAcademicYearData(this.SchoolData[this.School]);

            this.StandardData = {
                "All": 0,
                "1": 1,
                "2": 2,
                "3": 3,
                "4": 4,
                "5": 5,
                "6": 6,
                "7": 7
            }
        })
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad ErpAdmissionPage');
    }

    active_School_tab(tab) {
        console.log(tab);
        this.School = tab;
        this.active_tab(this.Standard);
        this.loadAcademicYearData(this.SchoolData[this.School]);
    }

    active_tab(tab) {
        console.log(tab);
        this.Standard = tab;
        this.DataSearch = null;
        this.AdmissionData = [];
        this.Page = 1;
        this.IsSearch = 0;
        this.loadvalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.AcademicYear, this.Page);
        this.loadCountvalues(this.SchoolData[this.School], this.AcademicYear);
    }

    loadAcademicYearData(SchoolId) {
        this.service.httpcall('web_service/get_academic_year_by_school_id?FSchoolId=' + SchoolId).subscribe(data => {
            console.log(data);
            this.AcademicYearData = data;
            let AcademicYearDataCount = this.AcademicYearData.length;
            console.log(AcademicYearDataCount);
            this.AcademicYear = this.AcademicYearData[0]['Id'];
            console.log("Id", this.AcademicYear);
            this.getStudents();
        })
    }

    getStudents() {
        this.DataSearch = null;
        this.AdmissionData = [];
        this.Page = 1;
        this.IsSearch = 0;
        this.loadCountvalues(this.SchoolData[this.School], this.AcademicYear);
        this.loadvalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.AcademicYear, this.Page);
    }

    loadvalues(SchoolId, Standard, FAcademicYearId, page) {
        this.datanotfound = null;
        let loading = this.loadingCtrl.create({
            content: 'Loading'
        });
        if(this.Page==1){
            loading.present();
            setTimeout(() => {
                loading.dismiss();
                loading = undefined;
            }, 3000);
        }

        this.service.httpcall('web_service/get_students_from_admission?FSchoolId=' + SchoolId + '&FAcademicYearId=' + FAcademicYearId + '&Standard=' + Standard + '&Page=' + page).subscribe(data => {
            console.log(data);

            if(this.Page==1){
                if (loading)
                    loading.dismiss();
                loading = undefined;
            }

            if (data['response'] == "success") {
                for (let i = 0; i < data['Data'].length; i++) {
                    this.AdmissionData.push(data['Data'][i]);
                }
            } else {
                this.datanotfound = data['error_description'];
            }
        })
    }

    doInfinite(infiniteScroll) {
        if (this.IsSearch == 0) {
            console.log('Begin async operation');

            this.Page = this.Page + 1;
            console.log("page number ", this.Page);
            this.loadvalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.AcademicYear, this.Page);
            setTimeout(() => {
                // for (let i = 0; i < 30; i++) {
                //   this.items.push( this.items.length );
                // }
                console.log('Async operation has ended');
                infiniteScroll.complete();
            }, 500);
        } else {
            setTimeout(() => {
                // for (let i = 0; i < 30; i++) {
                //   this.items.push( this.items.length );
                // }
                console.log('Async operation has ended');
                infiniteScroll.complete();
            }, 500);
        }

    }

    loadCountvalues(School, FAcademicYearId) {
        this.service.httpcall('web_service/get_erp_admission_count?FSchoolId=' + School + '&FAcademicYearId=' + FAcademicYearId).subscribe(data => {
            console.log(data);
            this.StdCount_0 = data[0]['StdCount_0'];
            this.StdCount_1 = data[1]['StdCount_1'];
            this.StdCount_2 = data[2]['StdCount_2'];
            this.StdCount_3 = data[3]['StdCount_3'];
            this.StdCount_4 = data[4]['StdCount_4'];
            this.StdCount_5 = data[5]['StdCount_5'];
            this.StdCount_6 = data[6]['StdCount_6'];
            this.StdCount_7 = data[7]['StdCount_7'];
        })
    }

    searchData() {
        this.IsSearch = 1;
        let loading = this.loadingCtrl.create({
            content: 'Loading'
        });
        loading.present();
        setTimeout(() => {
            loading.dismiss();
        }, 5000);

        console.log("Search:", this.DataSearch);
        this.AdmissionData = [];
        this.datanotfound = null;
        this.service.httpcall('web_service/get_students_from_admission_search?FSchoolId=' + this.SchoolData[this.School] + '&FAcademicYearId=' + this.AcademicYear + '&Standard=' + this.StandardData[this.Standard] + '&Search=' + this.DataSearch).subscribe(data => {
            if (loading)
                loading.dismiss();
            loading = undefined;
            console.log(data);
            if (data['response'] == "success") {
                if (loading)
                    loading.dismiss();
                loading = undefined;
                this.datanotfound = null;
                this.AdmissionData = data['Data'];
            } else {
                if (loading)
                    loading.dismiss();
                loading = undefined;
                this.datanotfound = data['error_description'];
            }

        })
    }

    send_msg(enquirydata,BtnMsg) {

        console.log("Message -> ",BtnMsg);

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, BtnMsg, null, null);
                    }
                }
            ]
        });
        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + item[0], BtnMsg, null, null);
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }
    }

    send_msg1(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg, null, null);
                    }
                }
            ]
        });
        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + item[0], enquirydata.Msg, null, null);
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }
    }

    send_msg2(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg2, null, null);
                    }
                }
            ]
        });

        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + item[0], enquirydata.Msg2, null, null);
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }


    }

    send_msg3(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg3, null, null);
                    }
                }
            ]
        });

        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + item[0], enquirydata.Msg3, null, null);
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }


    }

    send_msg4(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg4, null, null);
                    }
                }
            ]
        });

        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + item[0], enquirydata.Msg4, null, null);
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }


    }

    send_msg5(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg5, null, null);
                    }
                }
            ]
        });

        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + item[0], enquirydata.Msg5, null, null);
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }


    }

    send_msg6(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg6, null, null);
                    }
                }
            ]
        });

        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + item[0], enquirydata.Msg6, null, null);
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }


    }

    send_msg7(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg7, null, null);
                    }
                }
            ]
        });

        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + item[0], enquirydata.Msg7, null, null);
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }


    }

    send_msg8(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg8, null, null);
                    }
                }
            ]
        });

        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + item[0], enquirydata.Msg8, null, null);
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }


    }

    go_to_fees(item) {
        let FeesModel = this.modalCtrl.create(FeesPage, {item: item, SchoolId: this.SchoolData[this.School]});
        FeesModel.onDidDismiss(data => {
            console.log(data);
            if (data == undefined) {

            } else {

            }
        });
        FeesModel.present();
    }

    call(enquirydata) {
        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Call',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);


                        console.log("Call -> ", data);
                        window.location.href = 'tel:' + data;

                    }
                }
            ]
        });

        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            console.log("Call -> ", item[0]);
            window.location.href = 'tel:' + item[0];
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }

    }

    whatsapp(enquirydata) {
        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'WhatsApp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);


                        console.log("Call -> ", data);
                        window.location.href = 'whatsapp://send?phone=+91' + data;

                    }
                }
            ]
        });

        let item = enquirydata.contact;
        console.log("item", item);
        console.log("itemlength", item.length);

        if (item.length == 1) {
            console.log("Call -> ", item[0]);
            window.location.href = 'whatsapp://send?phone=+91' + item[0];
        } else {
            if (item[0]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[0],
                    value: item[0],
                    checked: true
                })
            }

            if (item[1]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[1],
                    value: item[1]
                })
            }

            if (item[2]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[2],
                    value: item[2]
                })
            }

            if (item[3]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[3],
                    value: item[3]
                })
            }

            if (item[4]) {
                myAlert.addInput({
                    type: 'radio',
                    label: item[4],
                    value: item[4]
                })
            }

            myAlert.present();
        }

    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);
        this.DataSearch = null;
        this.AdmissionData = [];
        this.Page = 1;
        this.IsSearch = 0;
        this.loadvalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.AcademicYear, this.Page);
        this.loadCountvalues(this.SchoolData[this.School], this.AcademicYear);
        setTimeout(() => {
            console.log('Async operation has ended');
            refresher.complete();
        }, 2000);
    }
}



// WEBPACK FOOTER //
// ./src/pages/erp-admission/erp-admission.ts